// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';

import {Sequence} from 'components/Sequence';
import * as sequtil from 'molbio/SeqUtil';

import * as EditDistance from './EditDistance';

interface Props {
  originalBases: string;
  currentBases: string;
  sequence: Sequence;
  offset: number;
}

class EditsTable extends React.Component<Props> {
  static defaultProps = {
    offset: 0,
  };

  modelToDisplay = (pos: number): number => sequtil.modelToDisplay(pos, this.props.sequence.startIndex());

  describeEdit = ({action, initial, final, index}: EditDistance.BaseEdit): string | undefined => {
    index -= this.props.offset;
    switch (action) {
      case EditDistance.EditAction.SUBSTITUTION:
        return `Changed ${initial} to ${final} at ${this.modelToDisplay(index)}`;
      case EditDistance.EditAction.INSERTION:
        return `Inserted ${final} at ${this.modelToDisplay(index)}`;
      case EditDistance.EditAction.DELETION:
        return `Deleted ${initial} at ${this.modelToDisplay(index)}`;
      default:
        return undefined;
    }
  };

  override render(): JSX.Element {
    const edits = EditDistance.getEdits(this.props.originalBases, this.props.currentBases);
    return (
      <div>
        <h5>Knock-in edits</h5>
        <table className="table table-condensed table-hover">
          <tbody>
            {!edits.length ? (
              <tr>
                <td>No edits introduced yet</td>
              </tr>
            ) : (
              // eslint-disable-next-line no-restricted-syntax
              _.map(edits, (edit, i) => (
                <tr
                  key={`edit-${i}`}
                  onClick={() => {
                    const index = edit.index - this.props.offset;
                    if (!edit.final.length) {
                      this.props.sequence.selection().reset(index);
                    } else {
                      this.props.sequence.selection().setEndpoints(index, index + edit.final.length);
                    }
                    this.props.sequence.trigger('jump', index);
                  }}
                >
                  <td>{this.describeEdit(edit)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default EditsTable;
